<template>
  <div>
    <b-modal id="staffPosition" title="Staff Position" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Staff Position
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <table class="table">
          <tr>
            <th>Staff</th>
            <th>Stylist Position</th>
            <th>Hair Extension</th>
          </tr>
          <tr v-for="(staff, index) in selectedStaffs" :key="'staff_' + index">
            <td>
              <label class="form-label">{{ staff['name'] }}</label>
            </td>
            <td>
              <multiselect
                v-model="position[staff['id']]"
                :options="positions"
                :searchable="false"
                :show-labels="false"
                @select="positionChange"
                openDirection="below">
                <template slot="option" slot-scope="{ option }">{{ option }}</template>
              </multiselect>
            </td>
            <td>
              <multiselect
                v-model="hairExtension[staff['id']]"
                :options="hairExtensionPositions"
                :searchable="false"
                :show-labels="false"
                @select="positionChange"
                openDirection="below">
                <template slot="option" slot-scope="{ option }">{{ option }}</template>
              </multiselect>
            </td>
          </tr>
        </table>

      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "staffPosition",
  data() {
    return {
      showLoading: false,
      outlets: [],
      positions: ['Stylist', 'Assistant', 'Reception', 'Others'],
      hairExtensionPositions: ['Director', 'Senior', 'Assistant', 'Reception', 'Others'],
      staffs: [],
      selectedStaffs: [],

      selectedOutlet: {},
      position: {},
      hairExtension: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('staffPosition')
      this.loadStaff()
    },

    onOutletChange() {
      this.selectedStaffs = []
      for (let staff of this.staffs) {
        if (this.selectedOutlet.id === staff['outletID']) {
          this.selectedStaffs.push({ id: staff['staffID'], name: staff['name'] + ' - ' + staff['mobile'], outletID: staff['outletID'] })
        }
      }

      this.data = {}
      this.loadCommission()
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_AKHair_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_AKHair_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          // this.data = response.data

          // response.data = JSON.parse('{"34717":{"position":"Others","hairextension":"Others"},"43307":{"position":"Reception","hairextension":"Reception"},"47373":{"position":"Assistant","hairextension":"Assistant"},"48630":{"position":"Stylist","hairextension":"Senior"},"48867":{"position":"Others","hairextension":"Director"},"50857":{"position":"Reception","hairextension":"Others"},"50858":{"position":"Assistant","hairextension":"Reception"},"54177":{"position":"Stylist","hairextension":"Assistant"},"57376":{"position":"Others","hairextension":"Senior"},"59609":{"position":"Reception","hairextension":"Director"},"60803":{"position":"Assistant","hairextension":"Others"},"61824":{"position":"Stylist","hairextension":"Reception"},"62376":{"position":"Others","hairextension":"Assistant"},"62378":{"position":"Reception","hairextension":"Senior"},"63097":{"position":"Assistant","hairextension":"Director"},"63470":{"position":"Stylist","hairextension":"Others"},"64206":{"position":"Others","hairextension":"Reception"},"67790":{"position":"Reception","hairextension":"Assistant"},"69551":{"position":"Assistant","hairextension":"Senior"},"69552":{"position":"Stylist","hairextension":"Director"}}')
          // console.log(response.data)
          
          this.position = {}
          this.hairExtension = {}

          for(let staffID in response.data) {
            response.data[staffID] = response.data[staffID] || {}
            this.position[staffID] = response.data[staffID].position
            this.hairExtension[staffID] = response.data[staffID].hairextension
          }
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    positionChange() {
      this.$forceUpdate()
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let staff of this.selectedStaffs) {
        let staffID = staff['id']
        request[staffID] = request[staffID] || {}
        request[staffID]['position'] = this.position[staffID]
        request[staffID]['hairextension'] = this.hairExtension[staffID]
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_AKHair_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_AKHair_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('staffPosition')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>